import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "popupContainer" }

import { computed, PropType } from 'vue'
import PromotionCard from './components/promotionCard.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData } from '@/view/promotion/supporrtScript';
import CustomHeader from '../components/common/customHeader.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionPopup',
  props: {
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
},
  emits: ['open', 'close', "openAgentPopup", "openPWAPopup", 'update:show'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore()
const { t } = useI18n();

const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = __emit
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
const openAgentPopup = () => {
    emits("openAgentPopup")
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}
const isShowCard = (name: string) => {
    if (name === 'pwa_reward') {
        const hasPwaInfo = userStore.PWAConvertData
        if (hasPwaInfo) {
            return true
        } else {
            return false
        }

    } else {
        return true
    }
}

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        zIndex:'1998'

    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: _ctx.$t('footer.bonus'),
          isPopupCloseBackIcon: true,
          onClosePopup: close
        }, null, 8, ["text"]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card_list" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.promotionList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (isShowCard(item.name))
              ? (_openBlock(), _createBlock(PromotionCard, {
                  key: 0,
                  itemData: item,
                  "un-claimed-count": _unref(activityCount)(_unref(userStore).unreadActivityMsgList, item?.id),
                  onOpenAgentPopup: openAgentPopup,
                  onGoToHome: close,
                  onOpenPWA: openPWAPopup
                }, null, 8, ["itemData", "un-claimed-count"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})